module.exports = __webpack_public_path__ + "images/517e171f680602897ecd57bc07bffade.svg";